import React from 'react';
import OrderSelect, { OrderSelectProps } from '../../../../../../Common/Select';

const BatteryTypeList = [
  { value: 'Lithium Metal', label: 'Lithium Metal' },
  { value: 'Lithium Ion', label: 'Lithium Ion' },
  { value: 'Sodium Ion', label: 'Sodium Ion' },
];

function SelectBatteryType({ selectProps, ...props }: OrderSelectProps) {
  return (
    <OrderSelect
      options={BatteryTypeList}
      {...props}
      selectProps={{
        placeholder: 'Select battery type',
        ...(selectProps || {}),
      }}
    />
  );
}

export default SelectBatteryType;
